import React from 'react';
import { InstituteTutorModel } from '../../../../../models/InstituteModel/tutor.model';
import { InstituteTutorService } from '../../../../../services/InstituteService/tutor.service';
import PasswordUpdateDrawer from '../../../../../shared/components/PasswordUpdateDrawer';

interface TeacherPasswordFormProps {
  open: boolean;
  onClose: () => void;
  setOpen: Function;
  tutorData: InstituteTutorModel;
}

export const TeacherPasswordForm: React.FC<TeacherPasswordFormProps> = ({ open, onClose, tutorData, setOpen }) => {

  const updatePassword = (values: { password: string; confirmPassword: string }) => {
    InstituteTutorService.updatePassword(
      tutorData.id,
      values.password,
      () => setOpen(false)
    );
  };

  return (
    <PasswordUpdateDrawer
      open={open}
      onClose={onClose}
      onSubmit={updatePassword}
    />
  );
};
